module.exports = __webpack_public_path__ + "img/icon-enkrypt-white.02f0ef33.svg";